


































































import CommonBase from "../CommonBase";
import {Component, Prop} from "vue-property-decorator";
import rd from "../../modules/vRoutedefs";
import {BackgroundLocationPermission} from "src/modules/models";

@Component
export default class EnableBackgroundLocationDlg extends CommonBase {
  @Prop({default: false})
  value!: boolean;
  @Prop()
  backgroundLocationPermission!: BackgroundLocationPermission;

  get model() {
    return this.value;
  }
  set model(v: boolean) {
    this.$emit("input", v);
  }

  get hasBackgroundPermission() {
    return this.backgroundLocationPermission.background;
  }

  get canAskForBackgroundPermission() {
    return this.backgroundLocationPermission.askAllowed();
  }

  answer(enabled: boolean) {
    this.$emit("at-enable-background-location", enabled);
  }

  cancel() {
    this.answer(false);
  }
  enable() {
    this.answer(true);
  }

  get privacyPolicyPath() {
    return rd.about.privacypolicy.path;
  }
}
